import { Store, Settings, LogOut } from "lucide-react";
import { Action } from "../../components/ui/Action";
import { Link, useHistory } from "react-router-dom";
import { logout } from "../../services/auth";
import { useMerchant } from "../../store/global/useMerchant";

export function Profile() {
  const history = useHistory()
  const merchant = useMerchant(st => st.data.merchant)
  return (
    <div className="w-full rounded-lg border-zinc-200/30 items-center justify-center shadow-md border p-4 gap-4 flex flex-col sm:col-span-1 sm:row-span-4 md:col-span-1 md:row-span-3 lg:col-span-1 lg:row-span-2 xl:col-span-2 xl:row-span-3 bg-white">
      <div className="flex flex-col gap-2 pt-2 items-center lg:flex-row">
        <div className="w-10 h-10 rounded-md flex items-center justify-center bg-scale-500 p-2">
          <Store className="w-full h-full text-white" />
        </div>
        <p className="flex text-sm flex-1 text-zinc-600 text-center lg:hidden xl:flex">{merchant?.name?.storeName || ''}</p>
      </div>
      <div className="w-full flex gap-2 [&>div]:w-full [&>div]:w-min-fit [&>div]:flex-1 md:mt-auto">
        <Action.Root outline asChild className="flex-1 w-full !max-w-full">
          <Link to="/configuracoes">
            <Action.Icon icon={Settings} />
          </Link>
        </Action.Root>
        <Action.Root
          outline
          onClick={() => {
            logout();
            history.push('/')
          }}
          className="flex-1 w-full !max-w-full"
        >
          <Action.Icon icon={LogOut} />
        </Action.Root>
      </div>
    </div>

  );
}
